import { Page } from "@/models/page-models/Page";

export const CreateSparePartTransfer: Page = {
  "path": "create-spare-part-transfer",
  "name": "Create Spare Parts Transfer",
  "props": {
    "data": {
      "title": "Create Spare Parts Transfer",
      "printable": "FALSE",
      "url": "create-spare-part-transfer",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.sparePart",
                  "label": "Select Spare Part",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedSparePart"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.allSpareParts.data",
                  "itemText": "description",
                  "itemValue": "_id"
                },
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Quantity",
                  "unit": "{{fetchedData.selectedSparePart.unit}}",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.locationTo",
                  "label": "Select Machine",
                  "disabled": "FALSE",
                  "items": "fetchedData.machines.data",
                  "itemText": "name",
                  "itemValue": "_id"
                },
                {
                  "type": "input",
                  "variable": "formData.department",
                  "label": "Department",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.requestedBy",
                  "label": "Requested By",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.description",
                  "label": "Description / Remarks",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Issue Spare Parts",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "createSparePartTransfer"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": false
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getAllSpareParts"
      },
      {
        "executionOrder": 1,
        "name": "getMachines"
      },
      {
        "executionOrder": 1,
        "name": "copyLocationFrom"
      }
    ],
    "functions": [
      {
        "name": "getAllSpareParts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/sparepart",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.allSpareParts"
      },
      {
        "name": "getMachines",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machines/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.machines"
      },
      {
        "name": "copySelectedSparePart",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedSparePart"
      },
      {
        "name": "createSparePartTransfer",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/spareparts/transfer/request",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getLocationFrom",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "locationFrom": "store"
        },
        "useFormula": true
      },
      {
        "name": "copyLocationFrom",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getLocationFrom",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": true
}